module.exports = __webpack_public_path__ + "static/pro-banner2@2x-98ca324027350a9515989b6717b635bc.jpg";